export enum roles {
    amazon_admin = "amazon-admin", // Access to amazon module
    amazon_generate = "amazon-generate", // Access to generate
    amazon_settings = "amazon-settings", // Access to settings
}